module.exports = __webpack_public_path__ + "static/media/address.24a73ae2.png";